"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isEqualLocation = void 0;
/**
 * There is a different precision for the coordinates returned by Oriflame data
 * and for the current coordinates returned by the map control. This is attempt to
 * compare the locations' coordinates with some rounding in place to skip many re-renders
 * with small coords differences.
 * @param location1 1st geographical location
 * @param location2 2nd geographical location
 * @returns True if both locations point approximately to the same place.
 */ const isEqualLocation = (location1, location2)=>{
    if (typeof location1 !== typeof location2) {
        return false;
    }
    if (location1 === undefined) {
        return true;
    }
    return location1.latitude.toFixed(7) === (location2 === null || location2 === void 0 ? void 0 : location2.latitude.toFixed(7)) && location1.longitude.toFixed(7) === location2.longitude.toFixed(7);
};
exports.isEqualLocation = isEqualLocation;
